import React from "react";
import { Link } from "react-router-dom";

function About() {
  return (
    <div>
      <h2 className="mt-3 text-center text-2xl font-semibold text-gray-900 sm:text-3xl">
        About the Conference
      </h2>
      {/* About Section */}
      <div className="bg-gray-50 py-16">
        <section>
          <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:items-center">
              <div>
                <div>
                  <p className="mt-4 text-pretty text-gray-700 leading-relaxed">
                    The{" "}
                    <strong>
                      6th Annual Management Representatives and Auditors
                      Conference
                    </strong>{" "}
                    a flagship event organized by the Kenya Bureau of Standards
                    (KEBS) through the National Quality Institute (NQI). Held
                    from 8th to 11th December 2025 at Sarova Whitesands,
                    Mombasa, the conference brings together management
                    representatives, internal and external auditors, compliance
                    professionals, industry leaders, and quality management
                    practitioners from across the country.
                  </p>
                </div>
              </div>

              <div>
                <img
                  src="../Assets/NQI TEAM.jpeg"
                  className="h-80 object-cover transition duration-500 group-hover:scale-105"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>
        {/* Second about section */}
        <section>
          <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 mt-10">
            <div className="grid grid-cols-1 gap-12 md:grid-cols-2 md:items-center">
              <div className="flex justify-center">
                <img
                  src="../Assets/team game.jpeg"
                  className=" w-full max-w-md object-cover rounded-lg transition duration-500 group-hover:scale-105"
                  alt=""
                />
              </div>

              <div>
                <p className="mt-4 text-pretty text-gray-700 leading-relaxed">
                  This year’s theme{" "}
                  <strong>
                    “Synergy in Systems: Coordinating for Excellence, Auditing
                    for Impact”
                  </strong>{" "}
                  highlights the growing need for organizations to strengthen
                  the integration of their management systems, improve audit
                  effectiveness, and enhance governance practices for
                  sustainable performance. Over four days, delegates will engage
                  in a rich program of keynote presentations, panel discussions,
                  technical sessions, and networking activities.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* Why Attend Section */}
      <section className="bg-gray-200 p-3">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-lg text-center">
            <h2 className="text-xl/tight font-bold text-gray-900 sm:text-4xl">
              About the Conference
            </h2>

            <p className="mt-4 text-lg text-pretty text-center text-gray-700 mb-6 leading-relaxed">
              Attending this conference equips you with practical tools,
              strategic insights, and the connections you need to elevate your
              organization’s performance. Here’s what you can expect
            </p>
          </div>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            <div className="flex items-start gap-4 rounded-lg border border-gray-200 p-6 dark:border-gray-700">
              <div className="inline-flex rounded-lg bg-[#0033A01A] p-3 rounded-lg text-[#0033A0]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
                  ></path>
                </svg>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  Gain Practical Insights from Industry Experts
                </h3>

                <p className="mt-2 text-pretty text-gray-700">
                  Learn directly from KEBS specialists, auditors, governance
                  leaders, and technical experts through sessions that address
                  real challenges faced in management systems, sustainability
                  practices, risk management, and quality assurance.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 rounded-lg border border-gray-200 p-6 dark:border-gray-700">
              <div className="inline-flex rounded-lg bg-[#0033A01A] p-3 rounded-lg text-[#0033A0]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                  ></path>
                </svg>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  Strengthen Your Auditing Skills for Greater Organizational
                  Impact
                </h3>

                <p className="mt-2 text-pretty text-gray-700">
                  With a full day dedicated to Auditing for Impact, you will
                  explore strategies for building sustainable quality assurance
                  programs, conducting effective audits, and applying techniques
                  such as root-cause analysis to drive measurable improvement.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 rounded-lg border border-gray-200 p-6 dark:border-gray-700">
              <div className="inline-flex rounded-lg bg-[#0033A01A] p-3 rounded-lg text-[#0033A0]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"
                  ></path>
                </svg>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  Explore Emerging Issues in Standards-Based Solutions
                </h3>

                <p className="mt-2 text-pretty text-gray-700">
                  Understand the latest challenges and developments in standards
                  implementation, compliance requirements, and quality
                  infrastructure - including upcoming issues shaping Kenyan
                  industries.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 rounded-lg border border-gray-200 p-6 dark:border-gray-700">
              <div className="inline-flex rounded-lg bg-[#0033A01A] p-3 rounded-lg text-[#0033A0]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6"
                  ></path>
                </svg>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  Network with Professionals, Leaders & Industry Peers
                </h3>

                <p className="mt-2 text-pretty text-gray-700">
                  Connect with KEBS representatives, management system auditors,
                  quality practitioners, regulators, and corporate leaders.
                  Build meaningful relationships that open doors for
                  collaboration and growth.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4 md:mt-8 flex justify-center">
          <button className="inline-block rounded-sm bg-[#0166b1] px-12 py-3 text-sm font-medium text-white transition hover:bg-emerald-700 focus:ring-2 focus:ring-yellow-400 focus:outline-hidden">
            <Link to="/registration">Register Now</Link>
          </button>
        </div>
      </section>
    </div>
  );
}

export default About;
